import { inject, injectable, named } from '../shared/inversify';
import type { PatSnapErrorResponseData } from './ps-http';
import { ContributionProvider } from './contribution-provider';

export const HttpErrorHandlerContribution = Symbol('HttpErrorHandlerContribution');

export interface HttpErrorHandlerContribution {
    /**
     * 注册错误处理器，针对 http 200 但是业务逻辑错误的情况/
     * @param handlers
     */
    registerHandler(handlers: HttpErrorHandlerRegistry): void;
}

export interface HttpErrorHandler<T = any> {
    (error: PatSnapErrorResponseData<T>): boolean;
}

export const HttpErrorHandlerRegistry = Symbol('HttpErrorHandlerRegistry');

export type HttpErrorHandlerType = 'http200' | '!http200'

export interface HttpErrorHandlerRegistry {
    register(type: HttpErrorHandlerType, handler: HttpErrorHandler): void;
    getHttpOkHandlers(): HttpErrorHandler[];
    getHttpErrorHandlers(): HttpErrorHandler[];
    onStart(): void;
}

/**
 * @deprecated
 * @description use ErrorHandler instead
 */
@injectable()
export class HttpErrorHandlerRegistryImpl implements HttpErrorHandlerRegistry {
    private _httpOkHandlers: HttpErrorHandler[] = [];
    private _httpErrorHandlers: HttpErrorHandler[] = [];

    constructor(
        @inject(ContributionProvider) @named(HttpErrorHandlerContribution)
        private _contributionProvider: ContributionProvider<HttpErrorHandlerContribution>,
    ) {
        //
    }

    onStart(): void {
        this._contributionProvider.getContributions().forEach(contribution => {
            contribution.registerHandler(this);
        });
    }

    register(type: HttpErrorHandlerType, handler: HttpErrorHandler) {
        if (type === 'http200') {
            this._httpOkHandlers.push(handler);
        } else if (type === '!http200') {
            this._httpErrorHandlers.push(handler);
        } else {
            throw new Error(`Unknown HttpErrorHandlerType ${type}, only support 'http200' and '!http200'`);
        }
    }

    getHttpOkHandlers() {
        return [...this._httpOkHandlers];
    }

    getHttpErrorHandlers() {
        return [...this._httpErrorHandlers];
    }
}
